// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__3brYT","formSpace":"styles_formSpace__ywa5r"};